export const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
        {
            '@type': 'Question',
            name: 'Was ist HorseDeal?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Mit HorseDeal, der Sharing-Plattform für Pferde, erhalten Pferdebesitzer:innen Zugang zu einer grossen Datenbank von qualifizierten und verfügbaren Pferdemenschen, die sich zeitlich und finanziell an ihrem Pferd beteiligen. Egal, ob eine kurzfristige Aushilfe, z. B. bei Abwesenheit, Krankheit, Schwangerschaft, oder eine langfristige Beteiligung, z. B. um ein Pferd regelmässig zu bewegen oder zu trainieren. Du als Pferdemensch findest in deiner Nähe eine vielfältige Auswahl an Pferden, die zu deinen Kenntnissen passen. So kommst Du zu deiner Dosis Pferdeluft, ganz ohne ein eigenes Pferd zu besitzen.',
            },
        },
        {
            '@type': 'Question',
            name: 'Was kostet HorseDeal?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'HorseDeal kannst Du völlig unverbindlich und kostenlos nutzen. Das Erstellen eines Reiter- oder Pferde-Profils sowie das Versenden von Anfragen ist für alle Mitglieder dauerhaft kostenlos.',
            },
        },
        {
            '@type': 'Question',
            name: 'Was sind Credits?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Wir nutzen Credits als unsere eigene Währung bei HorseDeal. Wenn Du eine Anfrage von einem anderen Mitglied erhältst, kannst Du vor einem Match das gesamte Profil sowie die Übereinstimmung auf Basis unseres Matchings vollständig einsehen. Erst für ein Match, d.h. das Akzeptieren einer Anfrage, werden Credits benötigt. Um noch mehr über unsere Funktionen und Preise zu erfahren, besuche die Seite „Preisgestaltung“.',
            },
        },
        {
            '@type': 'Question',
            name: 'Gibt es bezahlte Funktionen?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Richtig, es gibt bezahlte Funktionen bei HorseDeal. Diese werden mit Credits als Währung bezahlt. Für eine transparente Übersicht über die Kosten und Funktionen besuche die Seite „Preisgestaltung“ und scrolle zum Abschnitt „Wie viele Credits brauche ich?“. Zum Start erhältst Du kostenlose Credits, mit denen Du alle Funktionen risikofrei ausprobieren kannst. Auch später musst Du keine Credits kaufen - Du kannst sie jederzeit durch Rewards wie z. B. Freunde einladen oder Flip & Win kostenlos erhalten. Wenn Du einmal schnell mehr Credits benötigst, kannst Du sie auch ganz einfach als Paket mit 30, 150 oder 300 Credits nachkaufen. Weitere Informationen dazu findest Du ebenfalls auf der Seite „Preisgestaltung“ und scrolle zum Abschnitt „Credit-Pakete“.',
            },
        },
        {
            '@type': 'Question',
            name: 'Wie kann ich mich registrieren?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Um als Reiter:in, Spazierer:in oder Pfleger:in ein kostenloses Konto bei HorseDeal zu erstellen, besuche die Seite „Registrieren“. Die Voraussetzungen für eine Registrierung sind folgende: Du bist mindestens 12 Jahre alt, Du verfügst über kein Konto mit der gleichen E-Mail Adresse und Du verfügst über kein bestehendes, blockiertes Konto. Im nächsten Schritt kannst Du für deine Registrierung aus den folgenden drei Optionen auswählen: Registrierung mit Google, Registrierung mit Facebook, Registrierung mit Apple oder Registrierung mit E-Mail-Adresse und Passwort. In unserem Hilfe-Center zeigen wir dir Schritt für Schritt, wie Du dich mit nur wenigen Klicks als Mitglied registrieren kannst.',
            },
        },
        {
            '@type': 'Question',
            name: 'Wie kann ich Hilfe erhalten?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Benötigst Du Hilfe bei der Erstellung deines Kontos oder dem Ausfüllen deines Reiter-Profils? Wir sind für dich da und helfen dir sehr gerne weiter. Um uns zu kontaktieren, besuche die Seite „Kontakt“ und wähle aus einer der folgenden Kontaktmöglichkeiten: Hotline, Kontaktformular oder Beratungsgespräch. Gerne steht dir unser Team während unseren regulären Öffnungszeiten zur Verfügung. Unsere Öffnungszeiten: Montag: 08:00 - 18:00 Uhr, Dienstag: 08:00 - 18:00 Uhr, Mittwoch: 08:00 - 18:00 Uhr, Donnerstag: 08:00 - 18:00 Uhr und Freitag: 08:00 - 18:00 Uhr.',
            },
        },
        {
            '@type': 'Question',
            name: 'Gibt es eine Mobile-App?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Ja klar! Wir bieten eine App für Android und iOS an. HorseDeal-App für Android: Du kannst unsere App nahtlos auf dein Android-Smartphone herunterladen, indem Du im Playstore nach dem Begriff "HorseDeal" suchst. HorseDeal-App für iOS: Du kannst unsere App nahtlos auf dein iPhone herunterladen, indem Du im App Store nach dem Begriff "HorseDeal" suchst.',
            },
        },
    ],
};
